<template>
  <dx-modal :value="value" title="Solicitar Cancelamento" @input="close">
    <p>Para dar continuidade ao cancelamento, preencha as informações abaixo:</p>

    <div class="form-group" :class="{ 'has-error': $v.form.reason.$error }">
      <label for="reason" class="form-label">Motivo do cancelamento</label>
      <textarea
        id="reason"
        class="form-input"
        v-model="form.reason"
        rows="3"
        v-focus
      />
      <st-form-input-hint :validator="$v.form.reason" />
    </div>

    <div class="form-group">
      <label class="form-switch">
        <input type="checkbox" v-model="form.migrating" />
        <i class="form-icon"></i> Você está migrando para outro sistema?
      </label>
    </div>

    <div
      v-if="form.migrating"
      class="form-group"
      :class="{ 'has-error': $v.form.migratingTo.name.$error }"
    >
      <label for="migrating-to" class="form-label">Para qual sistema está migrando?</label>
      <div class="input-group">
        <select
          id="migrating-to"
          class="form-select"
          v-model="form.migratingTo.code"
        >
          <option value="">Selecione</option>
          <option
            v-for="item in systems"
            :key="item.code"
            :value="item.code"
          >{{ item.name }}</option>
        </select>
        <input
          v-if="form.migratingTo.code === 'other'"
          type="text"
          class="form-input"
          style="width: auto;"
          v-model="form.migratingTo.name"
          :placeholder="'Nome do sistema'"
          v-focus
        >
      </div>
      <st-form-input-hint :validator="$v.form.migratingTo.name" />
    </div>

    <template #footer>
      <button
        type="button"
        class="btn btn-error"
        :class="{ loading: requesting }"
        @click="request"
      >Solicitar Cancelamento</button>
      <button class="btn ml-2" @click="close">Sair</button>
    </template>
  </dx-modal>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators';

const systems = [
  { code: 'clinic', name: 'Clinic (Risc)' },
  { code: 'cnn', name: 'Clínica Nas Nuvens' },
  { code: 'consultabem', name: 'Consulta Bem' },
  { code: 'doctor_view', name: 'Doctor View' },
  { code: 'doctoralia', name: 'Doctoralia' },
  { code: 'feegow', name: 'Feegow' },
  { code: 'iclinic', name: 'iClinic (Afya)' },
  { code: 'mdmed', name: 'MDMed Web' },
  { code: 'med_plus', name: 'Med Plus' },
  { code: 'medx', name: 'Med X' },
  { code: 'mv', name: 'MV' },
  { code: 'personal_med', name: 'Personal Med' },
  { code: 'shosp', name: 'Shosp' },
  { code: 'tasy', name: 'Tasy' },
  { code: 'unimed', name: 'Unimed' },
  { code: 'other', name: 'Outro' },
];

export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      form: this.blankForm(),
      requesting: false,
      systems,
    };
  },
  validations() {
    const rules = {
      form: {
        reason: {
          required,
          minLength: minLength(15),
        },
        migratingTo: {},
      },
    };

    if (this.form.migrating) {
      rules.form.migratingTo.name = {
        required,
        minLength: minLength(3),
      };
    }

    return rules;
  },
  watch: {
    value() {
      if (this.value) {
        this.form = this.blankForm();
        this.$v.$reset();
      }
    },
    'form.migratingTo.code': function formMigratingToCode(newCode) {
      this.form.migratingTo.name = !['', 'other'].includes(newCode)
        ? systems.find(({ code }) => (code === newCode)).name
        : '';
    },
  },
  methods: {
    validateForm() {
      this.$v.$touch();
      return !this.$v.$error;
    },
    async request() {
      if (!this.validateForm()) return;

      this.requesting = true;

      try {
        await this.$http.post('/customer/cancellation-requests', {
          reason: this.form.reason,
          migrating: this.form.migrating,
          migratingTo: this.form.migrating ? this.form.migratingTo.name : '',
        });

        this.$dialog.show('', {
          html:
            '<div class="text-center">'
            + '<h5 class="">Solicitação enviada</h5>'
            + '<div>Sua solicitação de cancelamento foi enviada para o setor responsável.</div>'
            + '</div>',
        });

        this.close();
      } catch (e) {
        this.$toast.error(e);
      }

      this.requesting = false;
    },
    close() {
      this.$emit('input', false);
    },
    blankForm() {
      return {
        reason: '',
        migrating: false,
        migratingTo: { code: '', name: '' },
      };
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";
</style>
